<template>
    <div>
        <span v-if="item.supplier.price">
            {{ $filters.priceFormat(item.supplier.price.amount, item.supplier.price.currency) }}
            <span v-if="showSystemCurrency && currency !== item.currency">/ {{ supplierPriceInClientCurrency }}</span>
        </span>
        <template v-if="(isAgency || isTourOperator) && item.supplier.price.commission && commissionAndNettoCheckbox">
            <div class="commission text-grey">
                {{ $t('commission') }}:
                {{ $filters.priceFormat(item.supplier.price.commission, item.supplier.price.currency) }}
            </div>
            <div class="commission text-grey">
                {{ $t('net_amount') }}:
                {{
                    $filters.priceFormat(
                        item.supplier.price.amount - item.supplier.price.commission,
                        item.supplier.price.currency
                    )
                }}
            </div>
        </template>
        <payment-status-label
            v-if="showPaymentStatus && !$conf.public.account.paymentScheduler"
            :status="item.supplier.paymentStatus"
            :card-guarantee="item.supplier.cardGuarantee"
            class="text-no-wrap"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import PaymentStatusLabel from '~src/components/account/snippets/paymentStatusLabel.src'

    @Component({
        components: {PaymentStatusLabel},
    })
    export class OrdersSupplierPriceLabel extends Vue {
        @Prop({required: true}) item
        @Prop({default: true, type: Boolean}) showPaymentStatus
        @Prop({default: false}) showSystemCurrency

        get isAgency() {
            return authStore.isAgency
        }

        get isTourOperator() {
            return authStore.isTourOperator
        }

        get commissionAndNettoCheckbox() {
            return persistentStore.commissionAndNettoCheckbox
        }

        get currency() {
            return persistentStore.currency
        }

        get supplierPriceInClientCurrency() {
            const clientPriceCurrency = this.item.customer.price.currency
            const serviceOriginalXR = this.item.bookingXR || this.item.serviceCreationXR

            if (serviceOriginalXR) {
                return this.$filters.priceFormat(
                    this.item.supplier.price.amount * serviceOriginalXR,
                    clientPriceCurrency
                )
            } else {
                const priceConverted = this.$filters.convertPrice(this.item.supplier.price, clientPriceCurrency)

                return this.$filters.priceFormat(priceConverted.amount, priceConverted.currency)
            }
        }
    }

    export default OrdersSupplierPriceLabel
</script>

<style scoped lang="scss">
    .commission {
        font-size: 10px;
    }
</style>
